import(/* webpackMode: "eager" */ "/home/turath2/turath-websites/turath-website-learn/ur-prod/app/auth/error.tsx");
